import _ from 'underscore';

export const AudienceGroup = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Audience Group',
    },
    Id: {
      'bulk-upload-header': 'Id',
    },
    Name: {
      'bulk-upload-header': 'Audience Group Name',
    },
    Audiences: {
      'bulk-upload-header': 'Audiences',
      'bulk-upload-mapper': function (value) {
        return _.map(value, v => v.Id).join(';');
      },
    },
    AgeRanges: {
      'bulk-upload-header': 'Age Ranges',
      'bulk-upload-mapper': function (value) {
        return value.join(';');
      },
    },
    GenderTypes: {
      'bulk-upload-header': 'Gender Types',
      'bulk-upload-mapper': function (value) {
        return value.join(';');
      },
    },
  },
};
